import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { NavBar, Footer, ProtectedRoute } from './shared/components';
import './shared/App.css';

import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import Quizzes from './pages/Quizzes';
import Flashcards from './pages/Flashcards';
import Exams from './pages/Exams';
import Progress from './pages/Progress';
import AISettings from './pages/Settings';
import StudyGuide from './pages/StudyGuide';
import UniformSecuritiesAct from './pages/StudyGuide/UniformSecuritiesAct';
import InvestmentAdvisersAct from './pages/StudyGuide/InvestmentAdvisersAct';
import ModelRules from './pages/StudyGuide/ModelRules';
import EconomicFactors from './pages/StudyGuide/EconomicFactors';
import InvestmentVehicles from './pages/StudyGuide/InvestmentVehicles';
import ClientRecommendations from './pages/StudyGuide/ClientRecommendations';
import LawsAndRegulations from './pages/StudyGuide/LawsAndRegulations';

export default function App() {
  return (
    <div className="app-layout">
      <NavBar />
      <main className="app-content">
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/" element={<ProtectedRoute element={<Dashboard />} />} />
          <Route path="/quizzes" element={<ProtectedRoute element={<Quizzes />} />} />
          <Route path="/flashcards" element={<ProtectedRoute element={<Flashcards />} />} />
          <Route path="/exams" element={<ProtectedRoute element={<Exams />} />} />
          <Route path="/progress" element={<ProtectedRoute element={<Progress />} />} />
          <Route path="/settings/ai" element={<ProtectedRoute element={<AISettings />} />} />
          <Route path="/study-guide" element={<ProtectedRoute element={<StudyGuide />} />} />
          <Route path="/study-guide/uniform-securities-act" element={<ProtectedRoute element={<UniformSecuritiesAct />} />} />
          <Route path="/study-guide/investment-advisers-act" element={<ProtectedRoute element={<InvestmentAdvisersAct />} />} />
          <Route path="/study-guide/model-rules" element={<ProtectedRoute element={<ModelRules />} />} />
          <Route path="/study-guide/economic-factors" element={<ProtectedRoute element={<EconomicFactors />} />} />
          <Route path="/study-guide/investment-vehicles" element={<ProtectedRoute element={<InvestmentVehicles />} />} />
          <Route path="/study-guide/client-recommendations" element={<ProtectedRoute element={<ClientRecommendations />} />} />
          <Route path="/study-guide/laws-and-regulations" element={<ProtectedRoute element={<LawsAndRegulations />} />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}
